import { render, staticRenderFns } from "./1253_重构2行二进制矩阵.md?vue&type=template&id=54a5f830&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports